// native
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';

// service
import { DevSettingsService } from 'app/core/services/dev-settings.service';
import { ErrorService } from 'app/core/services/error.service';

// models
import { CenterContainerTitle, IDevSettingsConfig } from '../models';

@Component({
    selector: 'app-dev-settings',
    templateUrl: './dev-settings.component.html',
    standalone: false
})
export class DevSettingsComponent implements OnInit {
  form: UntypedFormGroup;
  title: CenterContainerTitle = {
    thin: 'developer',
    bold: 'settings'
  };
  isLoading: boolean = true;

  constructor(
    private devSettingsService: DevSettingsService,
    private formBuilder: UntypedFormBuilder,
    private errorService: ErrorService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.devSettingsService.getDevModeConfig().pipe(
      finalize(() => this.isLoading = false)
    ).subscribe(
      config => this.initializeForm(config),
      error => this.errorService.handleError(error)
    );
  }

  private initializeForm(config: IDevSettingsConfig) {
    this.form = this.formBuilder.group({
      research_mode: [!!config.research_mode],
      eye_telemetry_enabled: [!!config.eye_telemetry_enabled],
      blue_pupillometry_telemetry_enabled: [!!config.blue_pupillometry_telemetry_enabled],
      suprat_quadrant_telemetry_enabled: [!!config.suprat_quadrant_telemetry_enabled],
      sensorimotor_suite_cover_telemetry_enabled: [!!config.sensorimotor_suite_cover_telemetry_enabled],
      eoms_telemetry_enabled: [!!config.eoms_telemetry_enabled],
      pupillometry_telemetry_enabled: [!!config.pupillometry_telemetry_enabled],
      speech_reports: [!!config.speech_reports],
      waggoner_module: [!!config.waggoner_module],
      d15_voice_input_module: [!!config.d15_voice_input_module],
      enable_home_management: [!!config.enable_home_management]
    });
  }

  close() {
    this.router.navigate(['/patients']);
  }

  onSubmit(form: UntypedFormGroup) {
    this.isLoading = true;

    const {
      research_mode,
      eye_telemetry_enabled,
      blue_pupillometry_telemetry_enabled,
      suprat_quadrant_telemetry_enabled,
      sensorimotor_suite_cover_telemetry_enabled,
      eoms_telemetry_enabled,
      pupillometry_telemetry_enabled,
      speech_reports,
      waggoner_module,
      d15_voice_input_module,
      enable_home_management
    } = form.value;

    const body: Partial<IDevSettingsConfig> = {
      research_mode,
      eye_telemetry_enabled,
      blue_pupillometry_telemetry_enabled,
      suprat_quadrant_telemetry_enabled,
      sensorimotor_suite_cover_telemetry_enabled,
      eoms_telemetry_enabled,
      pupillometry_telemetry_enabled,
      speech_reports,
      waggoner_module,
      d15_voice_input_module,
      enable_home_management
    };

    this.devSettingsService.updateDevModeConfig(body).pipe(
      finalize(() => this.isLoading = false)
    ).subscribe(res => {
      this.close();
    });
  }
}
